import { z } from 'zod';

export const PositionChartGroupingPolicySchema = z.object({
  mode: z.enum(['grouped', 'individual']),
  roleKey: z.enum(['title', 'job_code']),
  includeDepartment: z.boolean(),
  includeLocation: z.boolean(),
});

export type PositionChartGroupingPolicy = z.infer<typeof PositionChartGroupingPolicySchema>;

export const DEFAULT_POSITION_CHART_GROUPING_POLICY: PositionChartGroupingPolicy = {
  mode: 'grouped',
  roleKey: 'title',
  includeDepartment: true,
  includeLocation: false,
};

export const POSITION_CHART_GROUPING_FILTER_KEY = 'positionChartGrouping';

export function resolvePositionChartGroupingPolicy(
  filters: Record<string, unknown> | null | undefined,
): PositionChartGroupingPolicy {
  const parsed = PositionChartGroupingPolicySchema.safeParse(
    filters?.[POSITION_CHART_GROUPING_FILTER_KEY],
  );
  return parsed.success ? parsed.data : DEFAULT_POSITION_CHART_GROUPING_POLICY;
}
